/**
 * Sommaire d'article.
 *
 * Construit la liste des titres de niveau 2 de l'article et pose une ancre sur
 * chacun. Sans JavaScript, l'article reste complet : seul le sommaire manque.
 */
class OligosanToc extends HTMLElement {
  connectedCallback() {
    const target = document.querySelector(this.getAttribute('for') || '.oligo-article__content');
    if (!target) return;

    const headings = Array.from(target.querySelectorAll('h2'));
    if (headings.length < 2) return;

    const list = document.createElement('ol');
    list.className = 'oligo-toc__list';

    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = (heading.textContent || `section-${index + 1}`)
          .toLowerCase()
          .normalize('NFD')
          .replace(/[̀-ͯ]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/(^-|-$)/g, '')
          .slice(0, 48);
        heading.id = base || `section-${index + 1}`;
      }

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.append(link);
      list.append(item);
    });

    this.append(list);
    this.removeAttribute('hidden');
  }
}

if (!customElements.get('oligosan-toc')) {
  customElements.define('oligosan-toc', OligosanToc);
}
